export default {
  "content": "<path d=\"M11.89 10.04L6.716 1.157a.833.833 0 00-1.431 0L.11 10.04a.809.809 0 00.715 1.21h10.35a.809.809 0 00.715-1.21zM6 9.75a.75.75 0 110-1.5.75.75 0 010 1.5zm.75-3a.75.75 0 11-1.5 0V4.5a.75.75 0 111.5 0v2.25z\" fill=\"currentColor\"/>",
  "attrs": {
    "width": "12",
    "height": "12",
    "viewBox": "0 0 12 12",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};